import * as React from 'react';

import { ScrollTrackingOverlay, SectionMarker } from './styled';
import { RICH_CONTENT_SECTION_PERCENTS } from './tracking';
import { useTrackRichContentSectionView } from './useTrackRichContentSectionView';

/**
 * Renders an invisible overlay split into three equally tall sections on top of
 * the rich content. Each section is observed to track how far the user scrolls
 * through the rich content. The overlay is not interactive and not visible.
 */
export const RichContentScrollTracker: React.FC = () => {
  const { setMarkerRef } = useTrackRichContentSectionView();

  return (
    <ScrollTrackingOverlay
      aria-hidden="true"
      data-testid="rich-content-scroll-tracker"
    >
      {RICH_CONTENT_SECTION_PERCENTS.map((percent, index) => (
        <SectionMarker key={percent} ref={setMarkerRef(index)} />
      ))}
    </ScrollTrackingOverlay>
  );
};
